import React from 'react'
import PurchasePage from '../../Components/client/PurchasePage'
function Prchasepage() {
  return (
    <div>
    <PurchasePage/>
    </div>
  )
}

export default Prchasepage
